import axios from '@/plugins/axios.js'

export const getApi = () => axios.get("/system/apiKey/get")
